import { render, staticRenderFns } from "./tableColConfig.vue?vue&type=template&id=084b83a9&scoped=true"
import script from "./tableColConfig.vue?vue&type=script&lang=js"
export * from "./tableColConfig.vue?vue&type=script&lang=js"
import style0 from "./tableColConfig.vue?vue&type=style&index=0&id=084b83a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b83a9",
  null
  
)

export default component.exports